module.exports = __webpack_public_path__ + "static/img/8.db52f5d.png";


//////////////////
// WEBPACK FOOTER
// ./static/honour/8.png
// module id = zM5e
// module chunks = 1